"use strict";

var _defineProperty = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/defineProperty.js");
var _objectWithoutProperties = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/objectWithoutProperties.js");
const _excluded = ["initialStartDate", "initialEndDate"],
  _excluded2 = ["className", "label", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangePicker = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("react-dates/initialize");
var _reactDates = require("react-dates");
var _moment = _interopRequireDefault(require("moment"));
var _classnames = _interopRequireDefault(require("classnames"));
var _label = _interopRequireDefault(require("../form/label"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
var _types = require("./types");
var _helpers = require("./helpers");
class DateRangePicker extends _react.default.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "onDatesChange", onChange => _ref => {
      let {
        startDate,
        endDate
      } = _ref;
      this.setState({
        startDate,
        endDate
      });
      if (onChange) {
        onChange({
          startDate,
          endDate
        });
      }
    });
    const {
        initialStartDate,
        initialEndDate
      } = props,
      rest = _objectWithoutProperties(props, _excluded);
    this.renderProps = rest;
    this.state = {
      startDate: initialStartDate && (0, _moment.default)(initialStartDate),
      endDate: initialEndDate && (0, _moment.default)(initialEndDate),
      focusedInput: null
    };
    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }
  onFocus(focusedInput) {
    this.setState({
      focusedInput
    });
  }
  render() {
    const _this$renderProps = this.renderProps,
      {
        className,
        label,
        onChange
      } = _this$renderProps,
      restProps = _objectWithoutProperties(_this$renderProps, _excluded2);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_indexModule.default.DateRangePicker, className)
    }, /*#__PURE__*/_react.default.createElement(_label.default, null, label), /*#__PURE__*/_react.default.createElement(_reactDates.DateRangePicker, (0, _extends2.default)({
      hideKeyboardShortcutsPanel: true,
      displayFormat: _helpers.longDateDisplayFormat,
      startDateId: "startDate",
      endDateId: "endDate",
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      focusedInput: this.state.focusedInput,
      minimumNights: this.props.minimumNights,
      onDatesChange: this.onDatesChange(onChange),
      onFocusChange: this.onFocus
    }, restProps)));
  }
}
exports.DateRangePicker = DateRangePicker;
DateRangePicker.propTypes = _objectSpread({
  initialStartDate: (0, _types.datePropType)(_moment.default),
  initialEndDate: (0, _types.datePropType)(_moment.default),
  minimumNights: _propTypes.default.number,
  className: _propTypes.default.string
}, _types.sharedPropTypes);
DateRangePicker.defaultProps = {
  minimumNights: 0
};